<template>
    <div>
        <loading-component :value="loading"/>
        <v-dialog :value="!!data.id" lazy>
            <v-card v-if="!!data.id">
                <v-card-title primary-title class="title font-weight-bold text-xs-center white--text green">
                    <v-spacer/>
                    Dispatch
                    <v-progress-circular :size="50" :width="5" :value="time" color="beige">
                        {{time}}
                    </v-progress-circular>
                    <v-spacer/>
                </v-card-title>
                <v-divider/>
                <v-card-text>
                    <v-layout>
                        <v-flex xs8 class="px-2">
                            <v-layout row wrap class="title">
                                <v-flex xs12 class="title"
                                        style="background-color: #eee; border-radius: 8px; text-align: center;">
                                    <v-layout justify-center align-center>
                                        <v-flex xs12 class="pa-2">
                                            <v-icon colro="#eee">calendar_today</v-icon>
                                            {{ formatCompanyTime(data.datetime, "DD / MM / YYYY") }}

                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                                <v-flex xs12 class="mt-5">
                                    <v-layout row wrap>
                                        <v-flex xs3 offset-xs4 class="pa-2 text-xs-center font-weight-bold"
                                                style="background-color: #C7C7C7; border-top-left-radius: 8px; border-top-right-radius: 8px">
                                            {{ formatCompanyTime(data.datetime, "HH:mm") }}
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                                <v-flex xs12>
                                    <v-layout wro wrap>
                                        <v-flex xs3 offset-xs4 class="pa-2 text-xs-center font-weight-bold"
                                                style="background-color: #E9E9E9;">
                                            {{ formatCompanyTime(data.ai_suggestion.min_pick_up_time, "HH:mm") }} -
                                            {{ formatCompanyTime(data.ai_suggestion.max_pick_up_time, "HH:mm") }}
                                        </v-flex>
                                        <v-flex xs3 offset-xs1 class="pa-2 text-xs-center font-weight-bold"
                                                style="background-color: #E9E9E9;border-top-left-radius: 8px; border-top-right-radius: 8px">
                                            {{ formatCompanyTime(data.ai_suggestion.min_drop_off_time, "HH:mm") }} -
                                            {{ formatCompanyTime(data.ai_suggestion.max_drop_off_time, "HH:mm") }}
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                                <v-flex xs12>
                                    <v-layout row wrap>
                                        <v-flex xs3 class="pa-5 text-xs-center display-2"
                                                style="background-color: #287EB6;border-top-left-radius: 8px; color: white;">
                                            {{data.ai_suggestion.captain.current_location_name}}
                                        </v-flex>
                                        <v-flex xs1 class="display-1 text-xs-center"
                                                style="color: white; background-color: #9B59B6">
                                            {{data.ai_suggestion.eta}}
                                            <br/>
                                            M
                                        </v-flex>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{on}">
                                                <v-flex xs3
                                                        v-on="on"
                                                        class="display-2 text-xs-center pa-5"
                                                        style="color: white;background-color: #4CAF50">

                                                    <div v-on="on">
                                                        {{data.pick_up_location_name}}
                                                    </div>
                                                </v-flex>
                                            </template>
                                            <span class="title">{{data.pick_up_location_details}}</span>
                                        </v-tooltip>
                                        <v-flex xs1 class="display-1 text-xs-center"
                                                style="color: white; background-color: #9B59B6">
                                            {{ data.ai_suggestion.min_drop_off_time && data.ai_suggestion.min_pick_up_time ? toCompanyMoment(data.ai_suggestion.min_drop_off_time).diff(toCompanyMoment(data.ai_suggestion.min_pick_up_time), 'minutes') : '-' }}
                                            <br/>
                                            M
                                        </v-flex>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{on}">
                                                <v-flex xs3 v-on="on"
                                                        class="display-2 text-xs-center pa-5"
                                                        style="color: white; background-color: #E74C3C;border-top-right-radius:8px;border-bottom-right-radius:8px;">
                                                    {{data.pull_down_location_name}}
                                                </v-flex>
                                            </template>
                                            <span class="title">{{data.pull_down_location_details}}</span>
                                        </v-tooltip>
                                    </v-layout>
                                </v-flex>
                                <v-flex xs12>
                                    <v-layout row wrap>
                                        <v-flex xs3 class="pa-2 text-xs-center font-weight-bold"
                                                style="background-color: #E9E9E9;border-bottom-left-radius: 8px;border-bottom-right-radius: 8px ">
                                            {{data.ai_suggestion.captain.first_name}}
                                            {{data.ai_suggestion.captain.last_name}}
                                        </v-flex>
                                        <v-flex xs3 offset-xs1 class="pa-2 text-xs-center font-weight-bold"
                                                style="background-color: #E9E9E9;border-bottom-left-radius: 8px;border-bottom-right-radius: 8px">
                                            {{data.passenger.first_name}}
                                            {{data.passenger.last_name}}
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                                <v-flex xs12 class="mt-2">
                                    <v-layout row wrap>
                                        <v-flex xs4>
                                            <v-btn color="#429C46" large class="title" @click="pass">
                                                Ok, Let AI Dispatch it
                                            </v-btn>
                                        </v-flex>
                                        <v-flex xs4 offset-xs4>
                                            <v-btn color="#E84C3D" large class="title" @click="snooze">
                                                Snooze
                                            </v-btn>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex xs4>
                            <div ref="map" id="map-snooze">
                                <div class="map-container">
                <span class="color-identifier"
                      :style="'background-color: green;min-width: 10px;padding: 3px 7px;font-size: 12px;font-weight: 700;line-height: 1;color: #fff;text-align: center;white-space: nowrap;vertical-align: middle;border-radius: 10px;'">From</span>
                                    <span class="color-identifier"
                                          :style="'background-color: red;min-width: 10px;padding: 3px 7px;font-size: 12px;font-weight: 700;line-height: 1;color: #fff;text-align: center;white-space: nowrap;vertical-align: middle;border-radius: 10px;'">To</span>
                                    <span class="color-identifier"
                                          :style="'background-color: blue;min-width: 10px;padding: 3px 7px;font-size: 12px;font-weight: 700;line-height: 1;color: #fff;text-align: center;white-space: nowrap;vertical-align: middle;border-radius: 10px;'">Captain Location</span>

                                </div>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>

    import Mapbox from "mapbox-gl";
    import RequestCard from "@/components/monaco/RequestCard";
    import { formatCompanyTime, toCompanyMoment, companyNow } from "@/util/companyTime";
    import popup from "@/assets/popup.mp3";
    import hasIntervalsMixin from "@/mixins/hasIntervalsMixin";
    import LoadingComponent from "@/components/LoadingComponent";

    export default {
        mixins: [hasIntervalsMixin],
        name: "SnoozePopup",
        components: {LoadingComponent, RequestCard},
        props: {
            data: {
                type: Object,
                required: true,
            }
        },
        data() {
            return {
                map: null,
                time: 150,
                loading: false
            }
        },
        mounted() {
            // (new Audio(popup)).play();
            Mapbox.accessToken = this.api.mapBox.accessToken;
            this.map = new Mapbox.Map(Object.assign({
                    container: 'map-snooze'
                },
                this.api.mapBox,
                {center: this.data.pick_up_location.coordinates}
            ));
            this.map.on('load', () => {
                this.map.resize();

                const pickUpLocation = this.data.pick_up_location.coordinates;
                const pullDownLocation = this.data.pull_down_location.coordinates;


                let marker = new Mapbox.Marker({
                    color: 'green'
                });
                marker.setLngLat(pickUpLocation);
                marker.addTo(this.map);

                marker = new Mapbox.Marker({
                    color: 'red',
                });
                marker.setLngLat(pullDownLocation);
                marker.addTo(this.map);
                if (this.data.ai_suggestion.captain) {
                    marker = new Mapbox.Marker({
                        color: 'blue'
                    });
                    marker.setLngLat(this.data.ai_suggestion.captain.current_location.coordinates);
                    marker.addTo(this.map);
                }
            });
            this.$refs.map.style.height = '400px';
            this.$refs.map.style.maxHeight = "640px"
        },
        intervals() {
            return [
                [this.updateTime, 1000]
            ];
        },
        methods: {
            pass() {
                this.loading = true;
                this.axios.post(`booking/${this.data.id}/let_ai_dispatch_it`)
                    .catch(
                        ({response: {data: {message}}}) => {
                            window.getApp.$emit("SHOW_TOAST", message, "red");
                        }
                    )
                    .finally(
                        () => this.loading = false
                    )
            },
            snooze() {
                this.axios.post(`booking/${this.data.id}/snooze`);
            },
            updateTime() {
                const until = toCompanyMoment(this.data.countdown_until);
                if (!until) {
                    return;
                }
                // Final-version doc 2026-10-05: instant compare, not PC time.
                this.time = until.diff(companyNow(), 'seconds');
                if (this.time <= 0) {
                    this.$store.state.socket.emit('Ai:pass_booking', this.data.id);
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    #map-snooze {
        position: relative;

        .map-container {
            padding: 8px;
            position: absolute;
            z-index: 1;
        }
    }

    .color-indicator {
        position: absolute;
        top: 0;
        left: 0;
        margin: 16px;
        z-index: 1;
    }

    .actions {
        padding: 8px;
        display: flex;
        justify-content: space-evenly;
        background-color: white;
        position: fixed;
        bottom: 10px;
        width: 100%;
    }

</style>
